// components/WhoIsItFor.jsx
import React, { useState } from 'react';
import '../CSS/LandingWhoIsItFor.css';
import callImage from '../../assets/call.jpg';
import EligibilityModal from '../../components/EligibilityModal'; // Chemin corrigé

const PmpWhoIsItFor = ({ scrollToCalendar, openEligibilityModal }) => {
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);

  const handleEligibilityComplete = (results) => {
    console.log('Résultats du questionnaire:', results);
    setShowEligibilityModal(false);
    
    // Rediriger vers l'inscription si recommandation PMP
    if (results.recommendation.certification === 'PMP') {
      scrollToCalendar();
    }
  };

  const profiles = [
    "Chefs de projet et responsables de projets",
    "Managers, ingénieurs et cadres opérationnels",
    "Entrepreneurs et dirigeants de PME",
    "Consultants, freelances et experts métiers",
    "Professionnels qui veulent accélérer leur carrière",
  ];

  return (
    <>
      <section className="landing-who-is-it-for" id="qui-est-ce-pour" style={{ marginBottom: "-80px" }}>
        <div className="landing-contenir">
          <h2 className="landing-section-title">À qui est destinée notre offre de préparation</h2>
          <p className="landing-section-subtitle">
            Notre programme s'adresse à tous les professionnels qui pilotent, coordonnent ou influencent des projets. Vous êtes concernés si vous êtes :
          </p>
          
          {/* LISTE À PUCES - MÊME STYLE QUE OurSupport */}
          <div className="landing-support-container">
            <ul className="landing-support-list">
              {profiles.map((item, index) => (
                <li key={index} className="landing-support-item">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <p className="landing-section-subtitle">
            Si vous êtes impliqués dans des projets, que vous voulez plus de contrôle, plus de résultats et plus de reconnaissance, cette formation est faite pour vous.
          </p>
        </div>
        
        {/* NOUVEAU BLOC: PASSEZ AU NIVEAU SUPÉRIEUR */}
        <div className="landing-next-level-section" style={{
          backgroundImage: `url(${callImage.src || callImage})`,
        }}>
          <div className="landing-next-level-overlay"></div>
          
          <h3 className="landing-next-level-title">
            Donnez un nouvel élan à votre carrière dès aujourd'hui !
          </h3>
          
          <div className="landing-next-level-buttons">
            <button 
              className="landing-eligibility-btn"
              onClick={openEligibilityModal}
            >
              Vérifier si vous êtes éligible
            </button>

            <button className="landing-join-btn" onClick={scrollToCalendar}>
              <span className="landing-join-text-desktop">Rejoignez notre prochain parcours PMP</span>
              <span className="landing-join-text-mobile">Rejoignez notre prochain parcours</span>
            </button>
          </div>
        </div>
      </section>

      {/* Modal d'éligibilité */}
      <EligibilityModal
        isOpen={showEligibilityModal}
        onClose={() => setShowEligibilityModal(false)}
        onComplete={handleEligibilityComplete}
      />

      <style jsx>{`
        /* Styles généraux - MÊME QUE OurSupport.jsx */
        .landing-support-container {
          margin: 3rem 0;
          background-color: #f8fafc;
          padding: 2.5rem;
          border-left: 4px solid #0a3764;
        }
        
        .landing-support-list {
          padding-left: 1.5rem;
          margin: 0;
          columns: 2;
          column-gap: 3rem;
        }
        
        .landing-support-item {
          font-size: 1.1rem;
          line-height: 1.6;
          margin-bottom: 1rem;
          color: #0a3764;
          break-inside: avoid;
        }
        
        /* Styles pour le bloc next-level */
        .landing-next-level-section {
          margin: 4rem auto 2rem;
          padding: 3rem;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          color: white;
          border-radius: 0px;
          text-align: center;
          position: relative;
          overflow: hidden;
          max-width: 1300px;
        }
        
        .landing-next-level-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.4);
          z-index: 0;
        }
        
        .landing-next-level-title {
          font-size: 2rem;
          margin-bottom: 1.5rem;
          font-weight: 700;
          position: relative;
          z-index: 1;
          color: white;
        }
        
        .landing-next-level-buttons {
          position: relative;
          z-index: 1;
          margin-top: 2rem;
          display: flex;
          justify-content: center;
          gap: 2rem;
          flex-wrap: wrap;
          align-items: stretch;
        }
        
        .landing-eligibility-btn, .landing-join-btn {
          padding: 1rem 2.5rem;
          font-size: 1.1rem;
          font-weight: 600;
          border: none;
          border-radius: 0px;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 250px;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          flex: 1;
          min-height: 60px;
          box-sizing: border-box;
          line-height: 1.2;
          white-space: normal;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        
        .landing-eligibility-btn {
          background-color: #94bf3e;
          color: white;
          border: 2px solid #94bf3e;
        }
        
        .landing-eligibility-btn:hover {
          background-color: #94bf3e;
          border-color: #f0f0f0;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(148, 191, 62, 0.3);
        }
        
        .landing-join-btn {
          background-color: #0a3764;
          color: white;
          border: 2px solid #0a3764;
        }
        
        .landing-join-btn:hover {
          background-color: #09407e;
          border-color: #09407e;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(10, 55, 100, 0.3);
        }
        
        .landing-join-text-desktop {
          display: inline;
        }
        
        .landing-join-text-mobile {
          display: none;
        }
        
        /* RESPONSIVE TABLET (768px - 1024px) */
        @media (max-width: 1024px) {
          .landing-support-list {
            columns: 2;
            column-gap: 2.5rem;
          }
          
          .landing-support-item {
            font-size: 1.05rem;
            line-height: 1.5;
          }
          
          .landing-next-level-section {
            padding: 2.5rem;
            max-width: 900px;
          }
          
          .landing-next-level-title {
            font-size: 1.8rem;
          }
        }
        
        /* RESPONSIVE MOBILE (≤768px) */
        @media (max-width: 768px) {
          .landing-support-container {
            padding: 2rem;
            margin: 2rem 0;
          }
          
          .landing-support-list {
            columns: 1 !important;
            column-gap: 0;
            padding-left: 1.2rem;
          }
          
          .landing-support-item {
            font-size: 1rem;
            line-height: 1.5;
            margin-bottom: 0.8rem;
          }
          
          .landing-next-level-section {
            padding: 2rem 1.5rem;
            margin: 3rem auto 1.5rem;
            max-width: 100%;
          }
          
          .landing-next-level-title {
            font-size: 1.5rem;
            margin-bottom: 1rem;
            line-height: 1.4;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 1rem;
            align-items: stretch;
            justify-content: center;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            width: auto;
            max-width: none;
            padding: 1rem 1.2rem;
            font-size: 1rem;
            min-width: auto;
            flex: 1;
            min-height: 55px;
          }
          
          .landing-join-text-desktop {
            display: none;
          }
          
          .landing-join-text-mobile {
            display: inline;
          }
        }
        
        /* RESPONSIVE PETIT MOBILE (≤480px) */
        @media (max-width: 480px) {
          .landing-support-container {
            padding: 1.5rem;
          }
          
          .landing-support-list {
            padding-left: 1rem;
          }
          
          .landing-support-item {
            font-size: 0.95rem;
            line-height: 1.5;
            margin-bottom: 0.7rem;
          }
          
          .landing-next-level-section {
            padding: 1.5rem 1rem;
          }
          
          .landing-next-level-title {
            font-size: 1.3rem;
            line-height: 1.4;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 0.8rem;
            align-items: stretch;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            font-size: 0.85rem;
            padding: 0.9rem 0.7rem;
            flex: 1;
            min-width: 120px;
            min-height: 50px;
          }
          
          .landing-join-text-mobile {
            font-size: 0.85rem;
          }
        }
        
        /* RESPONSIVE TRÈS PETIT MOBILE (≤360px) */
        @media (max-width: 360px) {
          .landing-support-container {
            padding: 1.2rem;
          }
          
          .landing-support-list {
            padding-left: 0.8rem;
          }
          
          .landing-support-item {
            font-size: 0.9rem;
            line-height: 1.4;
            margin-bottom: 0.6rem;
          }
          
          .landing-next-level-section {
            padding: 1.2rem 0.8rem;
          }
          
          .landing-next-level-title {
            font-size: 1.2rem;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 0.5rem;
            align-items: stretch;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            font-size: 0.78rem;
            padding: 0.8rem 0.5rem;
            min-width: 110px;
            min-height: 48px;
          }
          
          .landing-join-text-mobile {
            font-size: 0.78rem;
          }
        }
        
        /* Pour les écrans très larges (> 1200px) */
        @media (min-width: 1200px) {
          .landing-support-list {
            columns: 2;
            column-gap: 4rem;
          }
          
          .landing-support-item {
            font-size: 1.15rem;
          }
          
          .landing-next-level-section {
            max-width: 1300px;
          }
          
          .landing-next-level-title {
            font-size: 2.2rem;
          }
          
          .landing-next-level-buttons {
            align-items: stretch;
          }
        }
        
        /* Ajustement pour les très petits écrans (320px) */
        @media (max-width: 320px) {
          .landing-support-container {
            padding: 1rem;
          }
          
          .landing-support-list {
            padding-left: 0.6rem;
          }
          
          .landing-support-item {
            font-size: 0.85rem;
            line-height: 1.3;
            margin-bottom: 0.5rem;
          }
          
          .landing-next-level-section {
            padding: 1rem 0.6rem;
          }
          
          .landing-next-level-title {
            font-size: 1.1rem;
          }
          
          .landing-next-level-buttons {
            gap: 0.4rem;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            font-size: 0.75rem;
            padding: 0.75rem 0.4rem;
            min-height: 46px;
            line-height: 1.1;
          }
          
          .landing-join-text-mobile {
            font-size: 0.75rem;
          }
        }
      `}</style>
    </>
  );
};

export default PmpWhoIsItFor;